module.exports = __webpack_public_path__ + "static/assets/1cc752c6971ba9ab2f98fec83509120e.png";